'use es6';

import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { BUSINESS_UNIT_DROPDOWN_OPTION } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { isLoading, isError } from 'reference-resolvers/utils';
const sortBusinessUnitsByName = (buA, buB) => {
  if (buA.id === 0) {
    return -1;
  }
  if (buB.id === 0) {
    return 1;
  }
  return buA.name.toLocaleLowerCase().localeCompare(buB.name.toLocaleLowerCase());
};
export const provideBusinessUnitDropdown = ResolveReferences(({
  [BUSINESS_UNIT_DROPDOWN_OPTION]: resolver
}) => ({
  buOptions: resolver.all()
}));
export const mapReferenceResolverToPlainJS = resolverInstance => {
  if (isError(resolverInstance) || isLoading(resolverInstance)) {
    return [];
  }
  return resolverInstance.toJS().map(item => item.referencedObject).sort(sortBusinessUnitsByName);
};